var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pin_svg__a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.37 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.37 12c.55 0 1.02-.2 1.42-.59.39-.39.58-.86.58-1.41s-.2-1.02-.58-1.41c-.4-.4-.87-.59-1.42-.59s-1.02.2-1.4.59q-.6.585-.6 1.41t.6 1.41c.38.4.85.59 1.4.59m0 7.35a27.5 27.5 0 0 0 4.53-5.09c.98-1.52 1.47-2.88 1.47-4.06 0-1.82-.58-3.3-1.73-4.46A5.8 5.8 0 0 0 12.37 4a5.8 5.8 0 0 0-4.26 1.74 6.04 6.04 0 0 0-1.74 4.46c0 1.18.5 2.54 1.48 4.06.98 1.53 2.49 3.22 4.52 5.09m0 2.65a33.2 33.2 0 0 1-6-6.36c-1.33-1.96-2-3.77-2-5.44 0-2.5.8-4.5 2.42-5.97A8 8 0 0 1 12.37 2a8 8 0 0 1 5.6 2.22c1.6 1.49 2.4 3.48 2.4 5.98 0 1.67-.66 3.48-1.98 5.44A33.2 33.2 0 0 1 12.37 22"
  }))));
};
export default SvgPin;